// src/utils/helpers.js

export const uid = () =>
  Math.random().toString(36).slice(2, 10) + Date.now().toString(36);

export const genCode = () =>
  Math.random().toString(36).slice(2, 8).toUpperCase();

/** Fisher-Yates in-place shuffle returning a NEW array */
export function shuffle(arr) {
  const a = [...arr];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

/** Escape HTML entities to prevent XSS in dangerouslySetInnerHTML */
export function escHtml(str = "") {
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

/** Inject global CSS + favicon once */
export function injectGlobalStyles(css) {
  if (document.getElementById("omerta-styles")) return;
  const s = document.createElement("style");
  s.id = "omerta-styles";
  s.textContent = css;
  document.head.appendChild(s);
  // Tab favicon
  let link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.head.appendChild(link);
  }
  link.href =
    "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><text y='.9em' font-size='90'>🔪</text></svg>";
  document.title = "OMERTÀ — Mafia";
}

/** Resolve majority vote from a votes map { voterId: targetId } */
export function resolveMajority(votes = {}, eligibleVoterIds = []) {
  if (!eligibleVoterIds.length) return null;
  const tally = {};
  // Only count votes cast by eligible (alive) voters
  eligibleVoterIds.forEach((vid) => {
    const target = votes[vid];
    if (target) tally[target] = (tally[target] || 0) + 1;
  });
  if (!Object.keys(tally).length) return null;
  let max = 0, winner = null;
  for (const [id, count] of Object.entries(tally)) {
    if (count > max) { max = count; winner = id; }
  }
  return winner;
}

/**
 * Check win condition.
 * Returns: 'town' | 'town_doctors' | 'mafia' | null
 *
 * Win rules:
 *  - Town wins when all mafia are eliminated.
 *  - Mafia wins when mafia count >= non-mafia alive count (parity).
 *  - Special: if only 1 mafia + 2+ doctors remain (no citizens), town wins.
 */
export function checkWinCondition(players = []) {
  const alive       = players.filter((p) => p.alive);
  const aliveMafia  = alive.filter((p) => p.role === "mafia");
  const aliveDoctor = alive.filter((p) => p.role === "doctor");
  const aliveTown   = alive.filter((p) => p.role !== "mafia"); // doctors + citizens

  if (aliveMafia.length === 0) return "town";

  // Special doctor-parity win
  if (
    aliveMafia.length === 1 &&
    aliveDoctor.length >= 2 &&
    alive.length === aliveMafia.length + aliveDoctor.length
  ) return "town_doctors";

  // Mafia parity: mafia ≥ town (not just citizens)
  if (aliveMafia.length >= aliveTown.length) return "mafia";

  return null;
}
